const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 md:pt-0">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9a931ced09e3811d666736225d47ba3f.jpg"
          alt="Servicio profesional de vaciado y limpieza"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchpriority="high"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center">
        <div className="inline-block px-6 py-2 bg-silver-light/90 backdrop-blur-sm rounded-full mb-6 animate-fade-in">
          <span className="text-sm font-medium text-graphite">Servicio Profesional en Castelldefels</span>
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-slide-up">
          <span className="text-primary">Vaciado</span> de pisos y<br />
          <span className="text-primary">limpieza extrema</span> en Castelldefels
        </h1>

        <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          Especialistas en vaciado de pisos, locales comerciales y limpieza por síndrome de Diógenes. Servicio discreto, rápido y profesional disponible 24 horas, 7 días a la semana en <a href="https://barrinet.castelldefels.org/" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary transition-colors cursor-pointer">Castelldefels y toda la comarca del Baix Llobregat Sud</a>.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:+34602365996"
            className="w-full sm:w-auto px-8 py-4 bg-primary text-white rounded-lg font-semibold text-lg hover:bg-primary-dark hover:shadow-glow transition-all flex items-center justify-center space-x-2 cursor-pointer whitespace-nowrap animate-pulse-slow"
          >
            <i className="ri-phone-line text-xl"></i>
            <span>Llamar Ahora</span>
          </a>
          <a
            href="https://wa.me/34602365996"
            className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold text-lg hover:bg-white hover:text-primary transition-all flex items-center justify-center space-x-2 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            <span>WhatsApp</span>
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-time-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">24/7 Disponible</h3>
            <p className="text-white/80 text-sm">Servicio de urgencia cualquier día del año</p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-shield-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Servicio Discreto</h3>
            <p className="text-white/80 text-sm">Máxima confidencialidad garantizada</p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-file-list-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Sin Compromiso</h3>
            <p className="text-white/80 text-sm">Presupuesto gratuito y personalizado</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
